import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { loadStripe, StripeConstructorOptions } from '@stripe/stripe-js';
import useLocale from './use-locale';
import useShopForPageType from './use-shop-for-page-type';
import { getConfig } from '../Utils/utils';

const useStripeObject = () => {
  const shop = useShopForPageType();
  const { languageAsEnum } = useLocale();

  console.log('useStripeObject shop', shop);

  const stripeOptions = useMemo(() => {
    const options: StripeConstructorOptions = {
      locale: languageAsEnum,
    };

    if (!shop?.main && shop?.configuration?.stripePublicKey) {
      options.stripeAccount = shop.configuration.stripePublicKey;
    }

    console.log('useStripeObject computing stripeOptions', options);

    return options;
  }, [languageAsEnum, shop?.configuration?.stripePublicKey, shop?.main]);

  const { data: stripeObject } = useQuery({
    queryKey: ['stripeObject', shop?.id, stripeOptions],
    queryFn: async () => {
      console.log(
        'useStripeObject loading stripe',
        getConfig().stripeApiKey,
        stripeOptions
      );
      return await loadStripe(String(getConfig().stripeApiKey), stripeOptions);
    },
    enabled: Boolean(shop?.id),
  });

  return stripeObject;
};

export default useStripeObject;
